// extracted by mini-css-extract-plugin
export var carrierIcon = "_v6-0";
export var carrierLogo = "_v6-1";
export var detailsSection = "_v6-2";